<template>
  <v-card
    append
  >
    <div
      ref="cardImage"
      class="card_image"
      :style="imageStyle"
    >
      <img
        v-lazy="img"
        draggable="false"
        :style="{'opacity':(!loaded?0:1)}"
        @load="loadedCallback"
      >
      <lazy-component
        class="hashed_image_canvas"
        :style="{'opacity':(!loaded?1:0)}"
        @show="makeHashImage"
      >
        <canvas ref="hashedCanvas" />
      </lazy-component>
    </div>

    <!-- 하단 타이틀 클래스 pr-4 제거했음. -->
    <v-card-title class="pa-1">
      <v-container
        wrap
        fluid
        class="px-2 py-3"
      >
        <v-flex wrap>
          <slot />
        </v-flex>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { decode } from 'blurhash'

export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    imgHeight: {
      type: String,
      default: '240px'
    },
    hash: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      preload: false,
      loaded: false,
      imageWidth: 0
    }
  },
  computed: {
    imageStyle () {
      const TYPE_HEIGHT_RATIO = {
        pinkfongproducts: (428 / 428),
        licensedproducts: (285 / 428),
        mediacontent: (424 / 754)
      }
      const style = { height: `${this.imageWidth * TYPE_HEIGHT_RATIO[this.type]}px` }
      if (this.loaded) {
        return { height: 'auto' }
      } else {
        return style
      }
    }
  },
  mounted () {
    this.imageWidth = this.$el.clientWidth
    this.makeHashImage()
  },
  methods: {
    loadedCallback () {
      this.imageWidth = this.$el.clientWidth
      if (!this.preload) {
        this.preload = true
      } else {
        setTimeout(() => {
          this.loaded = true
        }, 300)
      }
    },
    makeHashImage () {
      if (this.$refs.hashedCanvas) {
        const DEFAULT_HASH = 'e1S?DV?bfQ?bfQ~qj[fQj[fQfQfQfQfQfQ~qj[fQj[fQfQfQfQfQfQ'
        this.$refs.hashedCanvas.width = 32
        this.$refs.hashedCanvas.height = 32
        const pixels = decode(this.hash ? this.hash : DEFAULT_HASH, 32, 32)
        const ctx = this.$refs.hashedCanvas.getContext('2d')
        const imageData = ctx.createImageData(this.$refs.hashedCanvas.width, this.$refs.hashedCanvas.height)
        imageData.data.set(pixels)
        ctx.putImageData(imageData, 0, 0)
      }
    }
  }
}
</script>

<style scoped>
.card-content {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: pre-line;
}

.card_image {
  width: auto;
  height: auto;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.hashed_image_canvas {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  opacity: 1;
  transition: opacity 0.3s ease-in;
}

.hashed_image_canvas canvas {
  width: 100%;
  height: 100%;
}

img[lazy='loaded'] {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue